import { loadStripe } from "@stripe/stripe-js"

let stripePromise
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(
      "pk_live_51ICUeUG9skj2Zj7qD9djuaU9mQvh9fEwHSR7wiOLixgWXaroCrmgDL8w1ZKZlhHhA7lynk8ux240wgtF3YA46IzF00WFLAYLvH"
    )
  }
  return stripePromise
}

export default getStripe;
